import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionProcessing.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Lottie from 'lottie-react';
import waitAnimation from "../Animations/waitAnimation.json";
import { toast } from 'react-toastify';
import { FaCopyright } from 'react-icons/fa6';
import { setUser } from '../slices/userSlice';
import { loginApi } from '../Api/api';
import { motion, useAnimation } from "framer-motion";
import { Canvas } from "@react-three/fiber";
import { Stars } from "@react-three/drei";

const SubscriptionProcessing = () => {
    const location = useLocation();
    const [msisdn, setMsisdn] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [attemptCount, setAttemptCount] = useState(0);

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            navigate("/");
        }
    }, [location]);

    useEffect(() => {
        let apiInterval = null;

        // if (!loading && msisdn && attemptCount < 100) {
        if (!loading && msisdn) {
            apiInterval = setInterval(() => {
                handleFormSubmission();
            }, 2000);
        }

        // if (attemptCount > 100) {
        //     toast.error("Something Went Wrong!");
        //     navigate("/login");
        // }

        return () => {
            if (apiInterval) {
                clearInterval(apiInterval);
            }
        };
    }, [msisdn, loading]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            await loginApi(msisdn)
                .then((res) => {
                    setLoading(false);
                    dispatch(setUser(res?.data?.result));
                    navigate("/app");
                    toast.success("Subscribed Successfully! Login...");
                })
                .catch((err) => {
                    setLoading(false);
                    setAttemptCount(prev => prev + 1);
                });
        } catch (error) {
            setLoading(false);
            setAttemptCount(prev => prev + 1);
            console.log(error, 'error--');
        }
    }

    return (

        <section className={classes.landing}>
            <motion.div
                className={classes.container}
                initial={{
                    backgroundImage: "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #f5b342)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #8e44ad)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #602A9A)",
                    ],
                }}
                transition={{
                    duration: 6,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                }}
            >
                <div className={classes.stars}>
                    <Canvas>
                        <Stars
                            radius={50}
                            depth={50}
                            count={1000}
                            factor={4}
                            saturation={0}
                            fade
                            speed={2}
                        />
                    </Canvas>
                </div>
            </motion.div>
            <div className={classes.main}>
                <header className={classes.header}>
                    <nav className={classes.nav}>
                        <div className={classes.logo_container}
                        >
                            <img
                                src="./assets/images/logo-white.png"
                                alt="ai"
                                className={classes.logo}
                            />
                        </div>

                        {/* <div className={classes.nav_sub_container}>
                            <button
                                type="button"
                                className={classes.sign_in_btn}
                                onClick={() => {
                                    navigate(`/login?ext_ref=${extRef}`)
                                }}
                            >
                                Login
                            </button>
                        </div> */}
                    </nav>
                </header>
                <div className={classes.product_description_container}>

                    <div className={classes.container_2}>
                        <div className={classes.description}>
                            <h2 className={classes.title}>Subscription In Process</h2>
                            <ul className={classes.list}>
                                <li className={classes.text}>
                                    Dear User, your subscription is in process!
                                </li>
                            </ul>

                            <div className={classes.animation_container}>
                                <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                            </div>

                            <p className={classes.text2}>
                                You will be auto redirected when successfully subscribed!
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>







    )
}

export default SubscriptionProcessing